import React, { useContext, useState } from 'react';

// Styles & Assets
import styles from './AddAssistentialStaff.module.css';

// Services
import { getFullName } from '../../../services/getPatientAtribute';

// Context
import FiltersContext from '../../../context/FiltersContext';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';

// Components
import CancelConfirmButtons from '../../UI/CancelConfirmButtons/CancelConfirmButtons';
import InputSelect from '../../UI/InputSelect/InputSelect';

// Models
import { OptionsSelect } from '../../../interfaces/Input';
import { Profile } from '../../../interfaces/Department';
import { UserData } from '../../../interfaces/UserInfo';
import { getEnvironmentApiUrl } from '../../../services/General';
interface PatientUser {
    id: number
    patient_id: number
    user_id: number
}
interface Props {
    assistentialStaff: UserData[]
    patientID: number
    closeModal: () => void
    onConfirm: (addedUsers: PatientUser) => void
}


const AddAssistentialStaff: React.FC<Props> = ({ assistentialStaff, patientID, closeModal, onConfirm }) => {

    const { t } = useTranslation();

    const { sendRequest } = useHttp<PatientUser>();

    const { profiles } = useContext(FiltersContext);
    const [profileID, setProfileID] = useState<Profile['id'] | null>(null);

    const [addedUsers, setAddedUsers] = useState<UserData['id'][]>([]);

    const handleChangeOption = (option: OptionsSelect) => {
        setProfileID(option.id === -1 ? null : Number(option.id));
    };

    const profilesOptions = [
        { id: -1, name: t('all') },
        ...profiles.map(p => ({ id: p.id, name: p.name ?? '' }))
    ];
    const defaultProfile = profiles.find(p => p.id === profileID);

    const handleAdd = (newID: UserData['id']) => () => {
        setAddedUsers(oldIDs => oldIDs.some(id => id === newID) ? oldIDs : [...oldIDs, newID]);
    };

    const handleConfirm = () => {
        addedUsers.forEach(id => {
            sendRequest({
                url: getEnvironmentApiUrl() + 'patient_users',
                method: 'POST',
                body: {
                    patient_id: patientID,
                    user_id: id,
                }
            }, (data) => {
                onConfirm(data);
            });
        });
        closeModal();
    };

    const filteredStaff = assistentialStaff.filter(u => profileID === null || u.profile_id === profileID);


    return (
        <div className='dialog'>
            <h1 className='dialogTitle'>
                {t('add_professional')}
            </h1>
            <h2 className={styles.subtitle}>
                {t('area')}
            </h2>
            <InputSelect
                options={profilesOptions}
                label=''
                value={defaultProfile?.name ?? t('all')}

                simpleStyles
                onChange={handleChangeOption}
                width={300}
            />
            <h2 className={styles.subtitle}>
                {t('professional')}
            </h2>
            <div className={styles.professionalList}>
                {filteredStaff.map(professional => {
                    const alreadyAdded = addedUsers.includes(professional.id);
                    return (<div className={styles.professional} key={professional.id}>
                        <div>
                            <p>{getFullName(professional)}</p>
                            <p className={styles.profile}>{profiles.find(p => p.id === professional.profile_id)?.name ?? '-'}</p>
                        </div>
                        <button
                            className={`${styles.buttonAdd} ${alreadyAdded ? styles.addedUser : ''}`}
                            onClick={handleAdd(professional.id)}
                        >
                            {alreadyAdded ? t('added') : t('add')}
                        </button>
                    </div>);
                }
                )}
            </div>
            <CancelConfirmButtons onCancel={closeModal} onConfirm={handleConfirm} />
        </div>
    );
};

export default AddAssistentialStaff;